import { createContext } from 'react';

import { DevPortalRoot } from './compositionRoot';

// Allow the asserted null because we will have this context or the app won't be loaded
// instead of littering the code with null checks for an impossible case, just assert it here.
export const DeveloperPortalRootContext = createContext<DevPortalRoot>(
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  undefined!
);
